import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-fixed-reward-consequence',
  templateUrl: './fixed-reward-consequence.component.html',
  styleUrls: ['./fixed-reward-consequence.component.scss'],
})
export class FixedRewardConsequenceComponent {
  @Input() fixedReward: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Input() rewardTypes: any;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  initConsequenceObject(): void {
    console.log(this.fixedReward);
    var tmpObj = {
      class: 'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Consequences$FixedReward',
    };
    if (this.fixedReward) {
      this.fixedReward.push(tmpObj);
    } else {
      this.fixedReward = [];
      this.fixedReward.push(tmpObj);
    }
    console.log(this.fixedReward);
  }

  updateConsequences() {
    this.debouncer.next(this.fixedReward);
  }

  removeConsequence(consequence) {
    this.fixedReward.splice(this.fixedReward.indexOf(consequence), 1);
    this.updateConsequences();
  }
}
